module.exports = __webpack_public_path__ + "2d98b3bd28c2df83d24914d4df0f7815.jpg";